/**
 * roleUtils.js
 * Tiện ích chuẩn hóa và hiển thị danh xưng vai trò (ADR 0029)
 */

export const ROLE_ALIASES = Object.freeze({
  operator: 'operations',
  op: 'operations',
  operator_manager: 'operations_lead',
  operations_manager: 'operations_lead',
  sale: 'sales',
  sale_lead: 'sales_lead',
  lead: 'sales_lead'
});

/**
 * Chuẩn hóa chuỗi vai trò về danh xưng chính quy
 */
export const canonicalizeRole = (role) => {
  if (!role || typeof role !== 'string') return '';
  const normalized = role.trim().toLowerCase();
  return ROLE_ALIASES[normalized] || normalized;
};

// Cụm vai trò Khối Điều hành
export const OPERATIONAL_ROLES = Object.freeze([
  'operations',
  'operations_lead',
  'group_operations',
  'group_operations_lead'
]);

// Cụm Trưởng nhóm Điều hành
export const OPERATIONAL_LEAD_ROLES = Object.freeze([
  'operations_lead',
  'group_operations_lead'
]);

// Các vai trò có toàn quyền điều hành tour (bao gồm cả Admin và Ban Quản lý)
export const ALL_OPERATION_PERMITTED_ROLES = Object.freeze([
  'admin',
  'ceo',
  'manager',
  'group_manager',
  ...OPERATIONAL_ROLES
]);

/**
 * Kiểm tra xem user hoặc role có thuộc nhóm có quyền Điều hành Tour hay không
 */
export const isOperationsRole = (userOrRole) => {
  if (!userOrRole) return false;
  const rawRole = typeof userOrRole === 'object' ? (userOrRole.role || userOrRole.role_name) : userOrRole;
  const role = canonicalizeRole(rawRole);
  return ALL_OPERATION_PERMITTED_ROLES.includes(role);
};

/**
 * Kiểm tra xem user có quyền chuyển trạng thái tour sang "Hoàn thành" hay không
 */
export const canFinalizeTour = (userOrRole) => {
  return isOperationsRole(userOrRole);
};

export const formatRoleDisplayName = (roleName) => {
    const canonical = canonicalizeRole(roleName);
    switch (canonical) {
      case 'admin': return 'Quản trị viên';
      case 'ceo': return 'Giám đốc Điều hành';
      case 'manager': return 'Trưởng phòng';
      case 'sales': return 'Sale';
      case 'sales_lead': return 'Trưởng nhóm Sale';
      case 'marketing': return 'Marketing';
      case 'marketing_lead': return 'Trưởng nhóm MKT';
      case 'operations': return 'Điều hành';
      case 'operations_lead': return 'Trưởng ĐH';
      case 'group_staff': return 'Sale BU3';
      case 'group_operations': return 'Điều hành BU3';
      case 'group_manager': return 'Trưởng nhóm BU3';
      case 'group_operations_lead': return 'Trưởng nhóm ĐH BU3';
      case 'accountant': return 'Kế toán';
      case 'accountant_lead': return 'Kế toán trưởng';
      default: return roleName ? String(roleName).replace(/_/g, ' ') : 'Nhân viên';
    }
};
